var React = require('react');

function Google (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"20","cy":"20","r":"20","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M26.6944 12.6041L23.9847 15.2337C20.5186 11.8458 13.7745 14.3138 13.7745 19.9914C13.7745 27.692 24.7047 28.2186 25.6529 21.9911H20.0003V18.5566H29.4273C30.4972 24.1491 26.886 29.9983 20.0003 29.9983V30C14.4527 30 10 25.5239 10 19.9997C10.0017 11.1043 20.5536 6.89983 26.6944 12.6041Z","fill":"white","key":1})]);
}

Google.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40"};

module.exports = Google;

Google.default = Google;
